export const getImageType = type => {
  let str = '';
  if (type === 'pdf' || type === 'PDF') {
    str = 'pdf';
  } else if (
    type === 'jpg' ||
    type === 'JPEG' ||
    type === 'JPG' ||
    type === 'jpeg' ||
    type === 'png' ||
    type === 'PNG' ||
    type === 'gif' ||
    type === 'GIF'
  ) {
    str = 'image';
  }
  return str;
};
